import Block from "./components/Block";

export default function App() {
  return (
    <Block></Block>
  );
}
